import React, { useState } from 'react';
import Banner from '../components/common/Banner';

const AdmissionPage = () => {
  const [activeSection, setActiveSection] = useState('process');

  const documents = [
    'Class 10th Mark Sheet and Certificate',
    'Class 12th Mark Sheet and Certificate (for B.Tech)',
    'JEE Main Score Card (if applicable)',
    'JEECUP Score Card (for Polytechnic)',
    'Transfer Certificate from previous institution',
    'Character Certificate from previous institution',
    'Caste Certificate (if applicable)',
    'Income Certificate (if applicable)',
    'Passport size photographs (6 copies)',
    'Aadhar Card copy',
    'Migration Certificate (for university students)',
    'Medical Certificate'
  ];

  const renderProcessSection = () => (
    <div className="space-y-8">
      <div className="mb-8">
        <h2 className="text-2xl sm:text-3xl font-serif font-bold text-slate mb-3 sm:mb-4">Admission Process</h2>
        <p className="text-gray-500">Step-by-step guide for admission to B.Tech and Polytechnic programs.</p>
      </div>

      <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 lg:gap-8">
        {/* B.Tech Admission */}
        <div className="bg-white p-4 sm:p-6 rounded-xl border border-border_gray">
          <h3 className="text-lg sm:text-xl font-bold text-crimson mb-4 sm:mb-6 flex items-center">
            <i className="fas fa-graduation-cap mr-2"></i>
            B.Tech Admission Process
          </h3>
          
          <div className="space-y-4">
            <div className="bg-surface p-4 rounded-lg border border-gray-200">
              <h4 className="font-semibold text-slate mb-2">Eligibility Criteria</h4>
              <ul className="text-sm sm:text-base text-gray-600 space-y-1">
                <li>• Passed 12th with Physics, Chemistry & Mathematics</li>
                <li>• Minimum 45% marks (40% for reserved categories)</li>
                <li>• Valid JEE Main score (preferred)</li>
                <li>• AKTU counseling participation</li>
              </ul>
            </div>
            
            <div className="bg-surface p-4 rounded-lg border border-gray-200">
              <h4 className="font-semibold text-slate mb-2">Application Process</h4>
              <ol className="text-sm sm:text-base text-gray-600 space-y-1">
                <li>1. Register for AKTU counseling</li>
                <li>2. Fill application form online</li>
                <li>3. Upload required documents</li>
                <li>4. Pay application fees</li>
                <li>5. Attend counseling sessions</li>
                <li>6. Seat allotment confirmation</li>
              </ol>
            </div>

            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
              <h4 className="font-semibold text-yellow-800 mb-2">Fee Structure</h4>
              <p className="text-yellow-700 text-sm">
                Fee details will be published according to AKTU norms and state government guidelines.
              </p>
            </div>
          </div>
        </div>

        {/* Polytechnic Admission */}
        <div className="bg-white p-4 sm:p-6 rounded-xl border border-border_gray">
          <h3 className="text-lg sm:text-xl font-bold text-crimson mb-4 sm:mb-6 flex items-center">
            <i className="fas fa-tools mr-2"></i>
            Polytechnic Admission Process
          </h3>
          
          <div className="space-y-4">
            <div className="bg-surface p-4 rounded-lg border border-gray-200">
              <h4 className="font-semibold text-slate mb-2">Eligibility Criteria</h4>
              <ul className="text-sm sm:text-base text-gray-600 space-y-1">
                <li>• Passed 10th from recognized board</li>
                <li>• Minimum 35% marks (30% for reserved categories)</li>
                <li>• JEECUP entrance exam qualification</li>
                <li>• BTE UP counseling participation</li>
              </ul>
            </div>
            
            <div className="bg-surface p-4 rounded-lg border border-gray-200">
              <h4 className="font-semibold text-slate mb-2">Application Process</h4>
              <ol className="text-sm sm:text-base text-gray-600 space-y-1">
                <li>1. Register for JEECUP exam</li>
                <li>2. Appear for entrance examination</li>
                <li>3. Fill online counseling form</li>
                <li>4. Document verification</li>
                <li>5. Choice filling and locking</li>
                <li>6. Seat allotment and admission</li>
              </ol>
            </div>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <h4 className="font-semibold text-blue-800 mb-2">Lateral Entry</h4>
              <p className="text-blue-700 text-sm">
                Direct admission to 2nd year for ITI/equivalent diploma holders with relevant experience.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderPaymentSection = () => (
    <div className="space-y-8">
      <div className="mb-8">
        <h2 className="text-2xl sm:text-3xl font-serif font-bold text-slate mb-3 sm:mb-4">Payment Procedure</h2>
        <p className="text-gray-500">Secure payment options and banking details for fee submission.</p>
      </div>

      <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 lg:gap-8">
        {/* Payment Instructions */}
        <div className="bg-white p-4 sm:p-6 rounded-xl border border-border_gray">
          <h3 className="text-lg sm:text-xl font-bold text-crimson mb-4 sm:mb-6">Payment Instructions</h3>
          
          <div className="space-y-4">
            <div className="bg-green-50 border border-green-200 rounded-lg p-4">
              <h4 className="font-semibold text-green-800 mb-2 flex items-center">
                <i className="fas fa-shield-alt mr-2"></i>
                Secure Payment Options
              </h4>
              <ul className="text-green-700 text-sm space-y-1">
                <li>• Online payment through college portal</li>
                <li>• Bank transfer/NEFT/RTGS</li>
                <li>• Demand Draft in favor of college</li>
                <li>• Cash payment at college office</li>
              </ul>
            </div>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <h4 className="font-semibold text-blue-800 mb-2">Payment Guidelines</h4>
              <ul className="text-blue-700 text-sm space-y-1">
                <li>• Keep payment receipt for verification</li>
                <li>• Payment confirmation within 24 hours</li>
                <li>• Late fee applicable after due date</li>
                <li>• Refund policy as per AKTU/BTE norms</li>
              </ul>
            </div>

            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
              <h4 className="font-semibold text-yellow-800 mb-2">Important Notes</h4>
              <ul className="text-yellow-700 text-sm space-y-1">
                <li>• All payments are non-refundable after admission confirmation</li>
                <li>• Fee structure subject to university/board revision</li>
                <li>• Scholarship benefits will be adjusted in final payment</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bank Details */}
        <div className="bg-white p-4 sm:p-6 rounded-xl border border-border_gray">
          <h3 className="text-lg sm:text-xl font-bold text-crimson mb-4 sm:mb-6">Bank Details</h3>
          
          <div className="space-y-6">
            <div className="bg-slate-50 p-4 rounded-lg border border-gray-200">
              <h4 className="font-semibold text-slate mb-4">For Fee Payment Transfer</h4>
              <div className="space-y-3 text-sm">
                <div className="flex justify-between">
                  <span className="font-medium text-gray-600">Account Name:</span>
                  <span className="font-semibold">FiT Engineering College</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-medium text-gray-600">Bank Name:</span>
                  <span className="font-semibold">[Bank Name]</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-medium text-gray-600">Account Number:</span>
                  <span className="font-semibold">[Account Number]</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-medium text-gray-600">IFSC Code:</span>
                  <span className="font-semibold">[IFSC Code]</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-medium text-gray-600">Branch:</span>
                  <span className="font-semibold">[Branch Name]</span>
                </div>
              </div>
            </div>

            <div className="bg-red-50 border border-red-200 rounded-lg p-4">
              <h4 className="font-semibold text-red-800 mb-2 flex items-center">
                <i className="fas fa-exclamation-triangle mr-2"></i>
                Important
              </h4>
              <p className="text-red-700 text-sm">
                Please mention student name and course details in payment remarks for easy identification.
              </p>
            </div>

            <div className="text-center pt-4">
              <button className="bg-crimson hover:bg-red-800 text-white font-bold py-3 px-6 rounded-lg transition">
                <i className="fas fa-download mr-2"></i>
                Download Fee Receipt Format
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderDocumentsSection = () => (
    <div className="space-y-8">
      <div className="mb-8">
        <h2 className="text-2xl sm:text-3xl font-serif font-bold text-slate mb-3 sm:mb-4">Document Checklist</h2>
        <p className="text-gray-500">Required documents for admission process and verification.</p>
      </div>

      <div className="bg-white p-4 sm:p-6 md:p-8 rounded-xl border border-border_gray">
        <h3 className="text-lg sm:text-xl font-bold text-crimson mb-4 sm:mb-6">Required Documents</h3>
        
        <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-x-4 sm:gap-x-8 gap-y-4">
          {documents.map((document, index) => (
            <div key={index} className="flex items-start space-x-3">
              <div className="bg-crimson text-white w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold mt-0.5 flex-shrink-0">
                {index + 1}
              </div>
              <span className="text-gray-700">{document}</span>
            </div>
          ))}
        </div>

        <div className="mt-8 p-4 bg-blue-50 border border-blue-200 rounded-lg">
          <h4 className="font-semibold text-blue-800 mb-2 flex items-center">
            <i className="fas fa-info-circle mr-2"></i>
            Document Guidelines
          </h4>
          <ul className="text-blue-700 text-sm space-y-1">
            <li>• All documents should be self-attested</li>
            <li>• Original documents required for verification</li>
            <li>• Documents in regional language should be translated</li>
            <li>• Additional documents may be required for specific categories</li>
          </ul>
        </div>
      </div>

      <div className="bg-white p-4 sm:p-6 rounded-xl border border-border_gray">
        <h3 className="text-lg sm:text-xl font-bold text-crimson mb-3 sm:mb-4">Helplines & Support</h3>
        <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
          <div className="bg-green-50 p-4 rounded-lg border border-green-200">
            <h4 className="font-semibold text-green-800 mb-2">Admission Helpline</h4>
            <p className="text-green-700 font-bold text-lg">1800-FIT-EDU</p>
            <p className="text-green-600 text-sm">Toll-free | 9 AM to 6 PM</p>
          </div>
          <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
            <h4 className="font-semibold text-blue-800 mb-2">Email Support</h4>
            <p className="text-blue-700 font-bold">admissions@fit.ac.in</p>
            <p className="text-blue-600 text-sm">Response within 24 hours</p>
          </div>
        </div>
      </div>
    </div>
  );

  const sections = [
    { id: 'process', label: 'Admission Process', component: renderProcessSection },
    { id: 'payment', label: 'Payment Procedure', component: renderPaymentSection },
    { id: 'documents', label: 'Document Checklist', component: renderDocumentsSection }
  ];

  return (
    <div className="h-full w-full  fade-in">
      <Banner 
        title="Admissions"
        subtitle="Join Our Community | Your Journey to Excellence Starts Here"
        imageSrc="https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80"
      />
      <div className="max-w-6xl mx-auto p-4 sm:p-6 md:p-10">
        
        {/* Section Navigation */}
        <div className="mb-6 sm:mb-8 border-b border-gray-200">
          <div className="flex space-x-4 sm:space-x-8 overflow-x-auto">
            {sections.map((section) => (
              <button
                key={section.id}
                onClick={() => setActiveSection(section.id)}
                className={`py-3 sm:py-4 px-2 border-b-2 font-semibold whitespace-nowrap transition-all ${
                  activeSection === section.id
                    ? 'border-crimson text-crimson'
                    : 'border-transparent text-gray-500 hover:text-gray-700'
                }`}
              >
                {section.label}
              </button>
            ))}
          </div>
        </div>

        {/* Active Section Content */}
        {sections.find(section => section.id === activeSection)?.component()}

      </div>
    </div>
  );
};

export default AdmissionPage;